module.exports = __webpack_public_path__ + "img/popularity-checked-in.cc68614b.png";